import { createContext, useContext } from 'react'

import { FlowChartState } from 'common/builder/components/chart/FlowChart/types/FlowChartState'

export const FlowChartStateContext = createContext<FlowChartState>({
  isReadonly: false,
  isNoStats: false,
  isPlayer: false,
  isAiAssistantMode: false,
  isNoInteractions: false,
  isPublished: false,
  isCreateTriggerAllowed: false,
  selectedTrigger: null,
  selectedNodes: {},
})

export const useFlowChartState = () => useContext(FlowChartStateContext)

export const FlowChartStateContextProvider = FlowChartStateContext.Provider
